<script>
import { mapState } from 'vuex'
export default {
    props: {
        searchRender: Function,
        handleSearch: Function,
        handleReset: Function,
        showQueryBtn: {
            type: Boolean,
            default: true,
        },
        showResetBtn: {
            type: Boolean,
            default: true,
        },
    },
    data () {
        return {
            closed: true,
            showMore: false,
            size: 'small'
        }
    },
    computed: {
        ...mapState('app', ['view'])
    },
    watch: {
        'view.width': {
            immediate: true,
            handler: function (newVal) {
                let size = 'large'
                if (!newVal || newVal < 1360) {
                    size = 'small'
                } else if (newVal >= 1360 && newVal <= 1640) {
                    size = 'medium'
                }
                this.size = size
                this.$nextTick(this.calcStatus)
            }
        }
    },
    render () {
        return (
            <div class={['basic-search', `basic-search--${this.size}`, this.closed ? 'basic-search--close' : 'basic-search--open']}>
                <div class="basic-search__bd">
                    <div class="col-l">
                        {this.searchRender()}
                    </div>
                    <div class="col-r">
                        {this.showQueryBtn && <el-button type="primary" size="small" onClick={this.handleSearch}>{this.$t('language.5o6trh9vn600')}</el-button>}
                        {this.showResetBtn && <el-button size="small" onClick={this.handleReset}>{this.$t('language.5o6trh9vn900')}</el-button>}
                        {this.showMore && <a title={this.$t('language.5o6u3rtvvb00')} class="toggle-more-btn" onClick={this.toggleMore}>{this.closed ? this.$t('language.5o6trh9vnbs0') : this.$t('language.5o6trh9vnek0')}</a>}
                    </div>
                </div>
            </div>
        )
    },
    methods: {
        calcStatus () {
            const formH = this.$el.querySelector('.basic-search__bd .el-form').offsetHeight
            if (formH > 105 ) {
                this.showMore = true
            } else {
                this.showMore = false
            }
            this.$emit('searchHeightChange', this.$el.offsetHeight)
        },
        toggleMore () {
            this.closed = !this.closed
            this.$nextTick(function () {
                this.$emit('searchHeightChange', this.$el.offsetHeight)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .heightset{
        height: 30%;
        display: flex;
        align-items: center;
        justify-content: center
    }
    .basic-search {
        padding: 20px 0 0;
    .basic-search__hd {
        display: flex;
        padding: 16px 0;
    .col-l {
        flex: 1;
    }
    .col-r {
        width: 162px;
    }
    }
    .basic-search__bd {
        display: flex;
    .col-l {
        flex: 1;
    .el-form {
        display: flex;
        flex-wrap: wrap;
    }
    /deep/ .el-form-item {
        padding-right: 15px;
        box-sizing: border-box;
    }
    }
    .col-r {
        position: relative;
        padding: 0 0 0 25px;
        width: 162px;
    .el-button {
        width: 75px;
    }

    .toggle-more-btn {
        position: absolute;
        display: inline-block;
        left: 36px;
        bottom: 3px;
        width: 60px;
        font-size: 12px;
        color: #3998FC;
        background: no-repeat center right;
        background-size: auto 9px;
    }
    }
    }
    }
    .basic-search--close {
    .basic-search__bd {
    .col-l {
        max-height: 102px;
        overflow: hidden;
    }
    .toggle-more-btn {
        background-image: url('../../../../imgs/icon-open.png');
    }
    }
    }
    .basic-search--open {
    .basic-search__bd {
    .col-l {
        max-height: none;
    }
    .toggle-more-btn {
        background-image: url('../../../../imgs/icon-close.png');
    }
    }
    }
    .basic-search--small {
    /deep/ .el-form-item {
        width: 33.33%;
    }
    /deep/ .span-2 {
        width: 66.67%;
    }
    }
    .basic-search--medium {
    /deep/ .el-form-item {
        width: 25%;
    }
    /deep/ .span-2 {
        width: 50%;
    }
    }
    .basic-search--large {
    /deep/ .el-form-item {
        width: 20%;
    }
    /deep/ .span-2 {
        width: 40%;
    }
    }
</style>
